import React from 'react';
import { Progress } from 'antd';
import Label from '../form/Label/Label';
import { FlexContainer } from '../Containers/FlexContainer/FlexContainer';
import './ProgressCreditUsage.scss';
import classnames from 'classnames';

const PotentialDialFormat = props => {
  const { totalCount } = props;
  return (
    <FlexContainer className="flex-column">
      <Label className=" bold fontGray500 m-text-20" tabIndex="-1">
        {totalCount}
      </Label>
    </FlexContainer>
  );
};

const ProgressCreditUsage = props => {
  const { percent, className, strokeFill } = props;

  const width = {
    large: 142,
    medium: 136,
    small: 72,
    ocfMedium: 124,
  };

  let progressClass = classnames('ProgressPotentialDial', className, {
    blue050: !strokeFill,
  });

  return (
    <div className={progressClass}>
      <Progress
        type="circle"
        percent={percent}
        success={{ percent: percent }}
        width={props?.size ? width[props?.size] : width['small']}
        className={strokeFill}
        aria-label={'progress percentage dial'}
        format={() => (
          <PotentialDialFormat totalCount={`${percent}%`} {...props} />
        )}
      />
    </div>
  );
};

export default ProgressCreditUsage;
